<i *ngIf="filter.type !== FILTER_TYPES.MODAL"
   class="fa fa-filter ms-3" [ngbPopover]="popover" [placement]="['bottom', 'right']" [autoClose]="'outside'"
   [class.text-info]="filter.value || filter.from || filter.to"
   #popoverButton="ngbPopover">
</i>
<ng-template #popover>
	<jhi-column-filter-text *ngIf="filter.type === FILTER_TYPES.TEXT"
							[filter]="filter"
							(onApply)="apply()"
							(onReset)="reset()">
	</jhi-column-filter-text>
	<jhi-column-filter-date *ngIf="filter.type === FILTER_TYPES.DATE"
							[filter]="filter"
							(onApply)="apply()"
							(onReset)="reset()">
	</jhi-column-filter-date>
	<jhi-column-filter-list *ngIf="filter.type === FILTER_TYPES.LIST"
							[filter]="filter"
							(onApply)="apply()"
							(onReset)="reset()">
	</jhi-column-filter-list>
	<jhi-column-filter-text-with-match-options *ngIf="filter.type === FILTER_TYPES.TEXT_WITH_MATCH_OPTIONS"
											   [filter]="filter"
											   (onApply)="apply()"
											   (onReset)="reset()">
	</jhi-column-filter-text-with-match-options>
	<!-- TODO complete as needed -->
</ng-template>
